module.exports = __webpack_public_path__ + "static/media/PROVE.bd925112.png";